var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcTableSort = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61993 15.578C8.5903 15.5562 8.5619 15.5311 8.53473 15.5049L3.96106 10.9609C3.8538 10.8557 3.78371 10.7251 3.75943 10.5852C3.73515 10.4453 3.75775 10.3022 3.82443 10.1735C3.89111 10.0448 3.99897 9.93613 4.13471 9.86091C4.27044 9.78568 4.42813 9.74719 4.58833 9.75016L13.4332 9.84833C13.5893 9.84995 13.7417 9.89074 13.8725 9.96594C14.0034 10.0411 14.1074 10.1477 14.1724 10.2731C14.2373 10.3985 14.2606 10.5376 14.2395 10.6743C14.2184 10.8109 14.1537 10.9394 14.053 11.0449L9.78434 15.4929C9.64257 15.64 9.44061 15.7316 9.22264 15.7475C9.00466 15.7634 8.78841 15.7025 8.62117 15.578L8.61993 15.578Z",
    fill: "#73756D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37714 2.42203C9.40677 2.44384 9.43517 2.46893 9.46234 2.49511L14.036 7.03912C14.1433 7.14428 14.2134 7.27486 14.2376 7.41477C14.2619 7.55468 14.2393 7.69781 14.1726 7.82651C14.106 7.95522 13.9981 8.06388 13.8624 8.1391C13.7266 8.21432 13.5689 8.25282 13.4087 8.24984L4.56391 8.15167C4.40779 8.15005 4.2554 8.10926 4.12452 8.03406C3.99364 7.95886 3.88966 7.85234 3.82469 7.72693C3.75972 7.60152 3.73645 7.46238 3.75758 7.32573C3.77871 7.18909 3.84338 7.06056 3.94404 6.95513L8.21273 2.5071C8.3545 2.35998 8.55646 2.26844 8.77443 2.2525C8.99241 2.23655 9.20866 2.29751 9.3759 2.42203L9.37714 2.42203Z",
    fill: "#73756D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcTableSort);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_table_sort.f9d0c88727ae2e0fb9174f938b67572e.svg";